const initialState = {
  perito: null,
  nombrePerito: null,
  entregador: null,
  nombreEntregador: null,
  dispositivoSuprema: null,
  reintentar: false,
  mostrarSnack: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'PERITO_AUTORIZANTE':
      return {
        ...state,
        perito: action.perito,
        nombrePerito: action.nombrePerito
      }
    case 'ENTREGADOR_AUTORIZANTE':
      return {
        ...state,
        entregador: action.entregador,
        nombreEntregador: action.nombreEntregador
      }
    case 'RESET_PERITO_AUTORIZANTE':
      return {
        ...state,
        perito: null,
        nombrePerito: null
      }
    case 'RESET_ENTREGADOR_AUTORIZANTE':
      return {
        ...state,
        entregador: null,
        nombreEntregador: null
      }
    case 'DISPOSITIVO_SUPREMA_CONECTADO':
      return {
        ...state,
        dispositivoSuprema: action.dispositivo
      }
    case 'REINTENTAR':
      return {
        ...state,
        reintentar: action.reintentar
      }
    case 'MOSTRAR_SNACK':
      return {
        ...state,
        mostrarSnack: action.mostrarSnack
      }
    default:
      return state
  }
}
